import { Download, FileText, Loader2, Upload } from "lucide-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { cn } from "@jbnl/shared-ui";
import { templateHref, useUploadTemplate } from "./useTemplate";

/** ADR-0071: one template, global - not scoped to a seizoen or a boekje like Versies is. */
export function Sjabloon() {
  const { t } = useTranslation("wedstrijdboekjes");
  const upload = useUploadTemplate();
  const inputRef = useRef<HTMLInputElement>(null);

  function kies(bestand: File | undefined) {
    if (!bestand) return;
    upload.mutate(bestand, {
      onSettled: () => {
        if (inputRef.current) inputRef.current.value = "";
      },
    });
  }

  return (
    <Card>
      <CardContent className="flex flex-col gap-4 p-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-muted">
            <FileText className="size-5 text-muted-foreground" />
          </div>
          <div>
            <p className="text-sm font-medium">{t("sjabloon.bestand")}</p>
            <p className="text-sm text-muted-foreground">
              {t("sjabloon.bestandType")}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          <Button asChild variant="outline">
            <a href={templateHref} download>
              <Download />
              {t("sjabloon.download")}
            </a>
          </Button>
          <Button
            type="button"
            variant="outline"
            disabled={upload.isPending}
            onClick={() => inputRef.current?.click()}
          >
            {upload.isPending ? (
              // sensor:allow codox-spinner pending button, not a loading state
              <Loader2 className="animate-spin" />
            ) : (
              <Upload />
            )}
            {upload.isPending
              ? t("sjabloon.bezigUploaden")
              : t("sjabloon.uploaden")}
          </Button>
          <input
            ref={inputRef}
            type="file"
            accept=".docx"
            className="hidden"
            onChange={(e) => kies(e.target.files?.[0])}
          />
        </div>
      </CardContent>

      {(upload.error || upload.isSuccess) && (
        <CardFooter className="border-t pt-4">
          <p
            className={cn(
              "text-sm",
              upload.error ? "text-destructive" : "text-muted-foreground",
            )}
          >
            {upload.error ? upload.error.message : t("sjabloon.geupload")}
          </p>
        </CardFooter>
      )}
    </Card>
  );
}
